import { useLocation } from "react-router-dom"
import { useBidsStore } from "@/stores/bids-store"
import { useDocumentTitle } from "@/hooks/useDocumentTitle"
import { resolveDocumentTitle } from "@/lib/document-title"

/**
 * The single owner of `document.title` inside the authenticated shell.
 * Renders nothing — mounted once by AppLayout so every /app route gets a
 * distinguishable tab title (bid managers keep several bids open in parallel).
 */
export function DocumentTitle() {
  const { pathname } = useLocation()
  const selectedBid = useBidsStore((s) => s.selectedBid)

  useDocumentTitle(resolveDocumentTitle(pathname, selectedBid))

  return null
}
